import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/AcquisitionConfiguration";

export const getAllAcquisition = async () => {
  return axios.get(`${api_base_url}`).then((res) => {
    return res;
  });
};

export const addAcquisition = async (acquisitionConfigData) => {
  const { data } = await axios.post(api_base_url, acquisitionConfigData);
  return data;
};

export const updateAcquisition = async (acquisitionConfigData) => {
  const { data } = await axios.put(api_base_url, acquisitionConfigData);
  return data;
};

export const deactivateAcquisition = async (acquisitionIds) => {
  const { data } = await axios.delete(api_base_url, {
    data: acquisitionIds,
  });

  return data;
};
